import React, { useState ,useRef} from "react";
import FormInputs from "../../../../components/UI/FormInputs";
import RadioButton from "../../../../components/UI/FormInputs/RadioButton";
import { convertUnderScoreStrings, isObject } from "../../../../utils/commonUtils";
import EmrVisitsService from "../../../../services/EmrVisitsService";

const AssessmentForm = ({
  visit_id,
  Toast,
  employee_id,
  selectedIcdCodes = [],
  formStates,
  setFormStates,
  setProgressApiTrigger
}) => {
  // const [formStates, setFormStates] = useState({});
  // console.log("selectedIcdCodes", selectedIcdCodes);
  const collapseRefs = useRef({});
  const assessmentFields = [
    {
      label: "Assessment",
      type: "Input",
      name: "assessment",
      id: "assessment",
      placeholder: "Assessment",
      disabled:true
    },
    {
      label: "ICD-10 DX",
      type: "Input",
      name: "icd10",
      id: "icd10",
      placeholder: "Search",
      disabled:true
    },
    {
      label: "Cause of Injury",
      type: "TextArea",
      name: "cause_of_injury",
      id: "cause_of_injury",
      rows: 4,
      placeholder: "Enter cause of injury",
    },
    {
      label: "Activity at Time of Injury",
      type: "TextArea",
      name: "activity_at_time_of_injury",
      id: "activity_at_time_of_injury",
      rows: 4,
      placeholder: "Enter activity at time of injury",
    },
    {
      label: "Physical Location Where Injury Occurred",
      type: "TextArea",
      name: "phys_injury_location",
      id: "phys_injury_location",
      rows: 4,
      placeholder: "Enter physical location",
    },
  ];
  const sectionFields = [
    {
      label: "Security Required",
      type: "RadioGroup",
      name: "security_required",
      id: "security_required",
      options: [
        { label: "No Special Security", value: "no_special_security" },
        { label: "EAP Access", value: "eap_access" },
        { label: "Personal Health and Wellness", value: "health_wealth" },
      ],
    },
    {
      label: "E&M Risk Level",
      type: "RadioGroup",
      name: "e_m_risk_problem",
      id: "e_m_risk_problem",
      options: [
        { label: "Minimal", value: "minimal" },
        { label: "Low", value: "low" },
        { label: "Moderate", value: "moderate" },
        { label: "High", value: "high" },
      ],
    },
    // {
    //   label: "Problem Count",
    //   type: "Input",
    //   name: "problemCount",
    //   id: "problemCount",
    //   placeholder: "Count",
    // },
    {
      label: "Chronicity",
      type: "RadioGroup",
      name: "chronicity",
      id: "chronicity",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Chronic", value: "chronic" },
        { label: "Acute", value: "acute" },
        { label: "Self Limited", value: "self_limited" },
      ],
    },
    {
      label: "Current Degree Of Control",
      type: "RadioGroup",
      name: "current_degree_control",
      id: "current_degree_control",
      options: [
        { label: "N/A", value: "na" },
        { label: "Controlled", value: "controlled" },
        { label: "Uncontrolled", value: "uncontrolled" },
        { label: "Questionable", value: "questionable" },
      ],
    },
  ];

  const locationSpecificityGroups = [
    {
      label: "Laterality",
      name: "location_left_right",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Left", value: "Left" },
        { label: "Right", value: "Right" },
        { label: "Bilateral", value: "Bilateral" },
      ],
    },
    {
      label: "Foot Surface",
      name: "location_plantar_dorsal",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Dorsal", value: "Dorsal" },
        { label: "Plantar", value: "Plantar" },
      ],
    },
    {
      label: "Side",
      name: "location_medial_lateral",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Medial", value: "Medial" },
        { label: "Lateral", value: "Lateral" },
      ],
    },
    {
      label: "Direction",
      name: "location_anterior_posterior",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Anterior", value: "Anterior" },
        { label: "Posterior", value: "Posterior" },
      ],
    },
    {
      label: "Position",
      name: "location_proximal_distal",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Proximal", value: "Proximal" },
        { label: "Distal", value: "Distal" },
      ],
    },
  ];

  const additionalAssessmentFields = [
    {
      label: "Intractable",
      type: "RadioGroup",
      name: "intractable",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
    },
    {
      label: "Condition (Pick any that apply)",
      type: "Checkbox",
      name: "condition",
      options: [
        { label: "Minor", value: "minor" },
        { label: "Uncomplicated", value: "uncomplicated" },
        { label: "Complicated", value: "complicated" },
        { label: "Systemic", value: "systemic" },
        { label: "Mild Exacerbation", value: "mild_exacerbation" },
        { label: "Severe Exaceberation", value: "Severe Exaceberation" },
        { label: "Life Threatining", value: "Life Threatining" },
      ],
    },
    {
      label: "Existing Problem Status",
      type: "Checkbox",
      name: "existing_problem",
      options: [
        { label: "Resolved", value: "resolved" },
        { label: "Stable", value: "stable" },
        { label: "Improved", value: "improved" },
        { label: "Worsening", value: "worsening" },
      ],
    },
    {
      label: "New Problem Status",
      type: "Checkbox",
      name: "new_problem",
      options: [
        {
          label: "Additional Work-up Required",
          value: "additional_workup_required",
        },
        {
          label: "No Additional Work-up Required",
          value: "no_additional_workup_required",
        },
      ],
    },
    {
      label: "Assesment Timing",
      type: "RadioGroup",
      name: "assessment_time",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Intial", value: "intial" },
        { label: "Subsequent", value: "subsequent" },
        { label: "Sequela", value: "sequela" },
      ],
    },
    {
      label: "Additional Notes",
      type: "TextArea",
      name: "additional_note",
      placeholder: "Enter notes here",
    },
  ];

  const updateFormState = (icdCode, field, value) => {
    setFormStates((prev) => ({
      ...prev,
      [icdCode]: {
        ...prev[icdCode],
        [field]: value,
      },
    }));
  };

  const handleDone = async (code,icd_id) => {
    try {

        const rawForm = formStates[code] || {};
      
        const payload = {
          ...rawForm,
          screen_type: "ASSESSMENT",
          employee_id: employee_id,
          condition: (rawForm.condition || []).join(","),
          existing_problem: (rawForm.existing_problem || []).join(","),
          new_problem: (rawForm.new_problem || []).join(","),
      
          cause_of_injury: rawForm.cause_of_injury || "",
          activity_at_time_of_injury: rawForm.activity_at_time_of_injury || "",
          phys_injury_location: rawForm.phys_injury_location || "",
          security_required: rawForm.security_required || "",
          e_m_risk_problem: rawForm.e_m_risk_problem || "",
          chronicity: rawForm.chronicity || "",
          current_degree_control: rawForm.current_degree_control || "",
          location_anterior_posterior: rawForm.location_anterior_posterior || "",
          location_left_right: rawForm.location_left_right || "",
          location_medial_lateral: rawForm.location_medial_lateral || "",
          location_plantar_dorsal: rawForm.location_plantar_dorsal || "",
          location_proximal_distal: rawForm.location_proximal_distal || "",
          intractable: rawForm.intractable || "",
          assessment_time: rawForm.assessment_time || "",
          additional_note: rawForm.additional_note || "",
        };
      
        const results = await EmrVisitsService.saveAssessment(
          null,
          visit_id,
          icd_id, 
          payload
        );
        setProgressApiTrigger((prev) => !prev);
        if (results?.status === 200 || results?.status === "SUCCESS") {
          Toast.success(`ICD ${code}: Data saved successfully.`);
        } else if (results.status === "ERROR") {
          const resultData = results.data;
          if (typeof resultData === "string") {
            Toast.error(`ICD ${code}: ${resultData}`);
          } else {
            Toast.error(`ICD ${code}: Submission failed.`);
          }
          return false; // stop on error
        }

      

      return true;
    } catch (error) {
      console.error("Save failed:", error);
      Toast.error("Something went wrong while saving.");
      return false;
    }
  };

  return (
    <div className="col-9">
      <div className="sh_emrcardrow">
        <div
          className="sh_cardBox sh_emrfieldcardbox mb-1"
          style={{ height: "calc(100vh - 490px)" }}
        >
          <div className="sh_cardBody p-0">
            <div className="space-y-6">
              {!selectedIcdCodes || selectedIcdCodes.length === 0 ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "40vh" }}
                >
                  <div className="alert alert-info text-center m-0">
                    No Charts and Fields Available. Please Add Charts.
                  </div>
                </div>
              ) : (
                selectedIcdCodes.map(({ code, icd_id,body_parts }, idx) => {
                  // const setSectionRef = (el) => {
                  //   if (el) sectionRefs.current[item.emr_form_id] = el;
                  // };

                  return (
                    <div className="card m-2" key={idx}>
                      <a
                        href={`#accordion-${idx}`}
                        className="d-block card-header sh_accordionheader accordion-button collapsed"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls={`accordion-${idx}`}
                      >
                        <h6 className="m-0 text-md">{code}</h6>
                      </a>
                      <div
                        className="accordion-collapse collapse show"
                        id={`accordion-${idx}`}
                        ref={(el) => (collapseRefs.current[code] = el)}
                      >
                        <div className="card-body py-2">
                          <div className="row">
                            {assessmentFields.map((field, idx) => (
                              <div className="col-6" key={field.name}>
                                <div className="form-group">
                                  {field.label && (
                                    <label
                                      className="mb-0 text-sm opacity-75 text-truncate"
                                      htmlFor={field.id}
                                    >
                                      {field.label}
                                    </label>
                                  )}
                                 <FormInputs
                                        {...field}
                                        value={
                                          field.name === "icd10"
                                            ? code
                                            : field.name === "assessment"
                                            ?convertUnderScoreStrings(body_parts) 
                                            : formStates[code]?.[field.name] || ""
                                        }
                                        changeHandler={(val) => updateFormState(code, field.name, val)}
                                      />

                                </div>
                              </div>
                            ))}

                            {sectionFields.map((field, idx) => (
                              <div className="col-12" key={idx}>
                                <div className="card w-100 mb-1">
                                  <div className="card-header sh_subaccordionheader d-flex justify-content-between align-items-center">
                                    <h6 className="text-sm mb-0">
                                      {field.label}
                                    </h6>
                                  </div>
                                  <div className="card-body py-2">
                                        <FormInputs
                                          {...field}
                                          type="RadioGroup"
                                          name={`${field.name}-${code}`}
                                          id={`${field.name}-${code}`}
                                          value={
                                            formStates[code]?.[field.name] ||
                                            ""
                                          }
                                          changeHandler={(val) =>
                                            updateFormState(
                                              code,
                                              field.name,
                                              val
                                            )
                                          }
                                        />
                                  </div>
                                </div>
                              </div>
                            ))}

                            {/* Location Specificity Section */}
                            <div className="col-12">
                              <div className="card w-100 mb-1">
                                <div className="card-header sh_subaccordionheader d-flex justify-content-between align-items-center">
                                  <h6 className="text-sm mb-0">
                                    Location Specificity
                                  </h6>
                                </div>
                                <div className="card-body py-0 px-0">
                                  <table className="table table-bordered table-sm mb-0">
                                    <tbody>
                                      {locationSpecificityGroups.map(
                                        (group, rowIndex) => (
                                          <tr key={`loc-row-${rowIndex}`}>
                                            <td className="align-middle">
                                              <div className="row px-2">
                                                {group.options.map(
                                                  (option, colIndex) => (
                                                    <div
                                                      key={`loc-${rowIndex}-${colIndex}`}
                                                      className="form-group col-6 mb-0"
                                                    >
                                                      <div className="row">
                                                        <div className="col-1">
                                                          <div className="form-check">
                                                            {/* <FormInputs
                                                        type="Radio"
                                                        name={group.name}
                                                        id={`loc-${rowIndex}-${colIndex}`}
                                                        value={
                                                          formStates[
                                                            group.name
                                                          ] === option.value
                                                        }
                                                        changeHandler={(
                                                          checked
                                                        ) => {
                                                          if (checked) {
                                                            setFormStates(
                                                              (prev) => ({
                                                                ...prev,
                                                                [group.name]:
                                                                  option.value, // ✅ Flattened into formStates
                                                              })
                                                            );
                                                          }
                                                        }}
                                                      /> */}
                                                            <FormInputs
                                                              type="Radio"
                                                              name={`${group.name}-${code}`}
                                                              id={`loc-${rowIndex}-${colIndex}-${code}`}
                                                              value={
                                                                formStates[
                                                                  code
                                                                ]?.[
                                                                  group.name
                                                                ] ===
                                                                option.value
                                                              }
                                                              changeHandler={(
                                                                checked
                                                              ) => {
                                                                if (checked) {
                                                                  setFormStates(
                                                                    (prev) => ({
                                                                      ...prev,
                                                                      [code]:
                                                                        {
                                                                          ...prev[
                                                                            code
                                                                          ],
                                                                          [group.name]:
                                                                            option.value,
                                                                        },
                                                                    })
                                                                  );
                                                                }
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                        <div className="col-10 d-flex align-items-center">
                                                        <label
                                                          className="formlabel mb-0"
                                                          htmlFor={`loc-${rowIndex}-${colIndex}-${code}`} 
                                                        >
                                                          {option.label}
                                                        </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            {additionalAssessmentFields.map((field, idx) => (
                              <div className="col-12" key={idx}>
                                <div className="card w-100 mb-1">
                                  <div className="card-header sh_subaccordionheader d-flex justify-content-between align-items-center">
                                    <h6 className="text-sm mb-0">
                                      {field.label}
                                    </h6>
                                  </div>
                                  <div className="card-body py-2">
                                      <div className="row">
                                        {/* RadioGroup Rendering */}
                                        {field.type === "RadioGroup" && (
                                          <FormInputs
                                            {...field}
                                            name={`${field.name}-${code}`}
                                            id={`${field.name}-${code}`} 
                                            type="RadioGroup"
                                            // value={formStates?.[field.name] || ""}
                                            // changeHandler={(val) =>
                                            //   // console.log(val)

                                            //   setFormStates((prev) => ({
                                            //     ...prev,
                                            //     [field.name]: val,
                                            //   }))
                                            // }
                                            value={
                                              formStates[code]?.[
                                                field.name
                                              ] || ""
                                            }
                                            changeHandler={(val) =>
                                              updateFormState(
                                                code,
                                                field.name,
                                                val
                                              )
                                            }
                                          />
                                        )}

                                        {/* Checkbox Rendering */}
                                        {field.type === "Checkbox" &&
                                          field.options.map((option, i) => {
                                            const isChecked =
                                              Array.isArray(
                                                formStates[code]?.[
                                                  field.name
                                                ]
                                              ) &&
                                              formStates[code][
                                                field.name
                                              ].includes(option.value);

                                            return (
                                              <div
                                                className="form-group col-6 mb-0"
                                                key={i}
                                              >
                                                <div className="form-check d-flex align-items-center">
                                                  <FormInputs
                                                    type="Checkbox"
                                                    id={`${field.name}-${i}-${code}`}
                                                    name={field.name}
                                                    value={
                                                      Array.isArray(
                                                        formStates[code]?.[
                                                          field.name
                                                        ]
                                                      ) &&
                                                      formStates[code][
                                                        field.name
                                                      ].includes(option.value)
                                                    }
                                                    changeHandler={(
                                                      checked
                                                    ) => {
                                                      const prevList =
                                                        Array.isArray(
                                                          formStates[code]?.[
                                                            field.name
                                                          ]
                                                        )
                                                          ? formStates[code][
                                                              field.name
                                                            ]
                                                          : [];

                                                      const updatedList =
                                                        checked
                                                          ? [
                                                              ...prevList,
                                                              option.value,
                                                            ]
                                                          : prevList.filter(
                                                              (v) =>
                                                                v !==
                                                                option.value
                                                            );

                                                      updateFormState(
                                                        code,
                                                        field.name,
                                                        updatedList
                                                      );
                                                    }}
                                                  />
                                                 <label
                                                  className="form-check-label pl-2 mb-0"
                                                  htmlFor={`${field.name}-${i}-${code}`} // ✅ matches input id exactly
                                                >
                                                  {option.label}
                                                </label>
                                                </div>
                                              </div>
                                            );
                                          })}

                                        {/* Textarea Rendering */}
                                        {field.type === "TextArea" && (
                                          <div className="form-group col-12 mb-0">
                                              <FormInputs
                                                {...field}
                                                type="TextArea"
                                                id={`${field.name}-${code}`}
                                                name={field.name}
                                                value={formStates[code]?.[field.name] || ""}
                                                changeHandler={(val) => updateFormState(code, field.name, val)}
                                              />
                                          </div>
                                        )}
                                      </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          {/* Add all additional sections here following the same JSX conversion */}
                          <div className="card-footer p-1 d-flex justify-content-center">
                          <button
                            className="btn btn-primary"
                            onClick={async () => {
                              const success = await handleDone(code, icd_id);

                              if (success) {
                                const el = collapseRefs.current[code];
                                if (el && window.bootstrap?.Collapse) {
                                  const collapseInstance = window.bootstrap.Collapse.getOrCreateInstance(el);
                                  collapseInstance.hide(); // ✅ collapse the accordion on success
                                }
                              }
                            }}
                          >
                            Done
                          </button>

                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentForm;
